import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostInitiativeTaskLinkRequest = {
	all?: boolean;
	initiativeId: number;
	initiativeScopeIds?: Array<number>;
	initiativeScopeIdsToExclude?: Array<number>;
	initiativeTaskId: number;
	objectNameSearchText?: string;
	objectTypes?: Array<string>;
	sonarObjectIds?: Array<number>;
};

export const postInitiativeTaskLink = createPostEndpoint<PostInitiativeTaskLinkRequest>(
	({ initiativeId, initiativeTaskId }) => `/api/v3/initiatives/${initiativeId}/tasks/${initiativeTaskId}/link`,
	{
		requestTransform: ({ initiativeId, initiativeTaskId, ...rest }) => ({ ...rest })
	}
);
